<script>



	let links = [
		{
			name: 'Beatport',
			link: 'https://www.beatport.com/artist/nela-abib/1047000',
			icon: 'beatport.png',
		},
		{
			name: 'SoundCloud',
			link: 'https://soundcloud.com/nelaabib',
			icon: 'soundcloud.png',
		},
		{
			name: 'Spotify',
			link: 'https://open.spotify.com/artist/6b8jlklPiHiC0dbJCRqBjx',
			icon: 'spotify.png',
		},
		{
			name: 'Apple Music',
			link: 'https://music.apple.com/us/artist/nela-abib/1564493602',
			icon: 'apple.png',
		},
		{
			name: 'Tidal',
			link: 'https://tidal.com/browse/artist/24545353',
			icon: 'tidal.png',
		},
		{
			name: 'Amazon Music',
			link: 'https://music.amazon.com/artists/B093BQQ1XB/nela-abib',
			icon: 'amazon.png',
		},
		{
			name: 'Deezer',
			link: 'https://www.deezer.com/us/artist/130801952?deferredFl=1',
			icon: 'deezer.png',
		},
		{
			name: 'YouTube',
			link: 'https://www.youtube.com/c/NelaAbib/videos',
			icon: 'youtube.png',
		},
		{
			name: 'TikTok',
			link: 'https://www.tiktok.com/music/A-10MIL-7031220238813267970',
			icon: 'tiktok.png',
		},
		{
			name: 'Twitch',
			link: 'https://www.twitch.tv/nelaabib',
			icon: 'twitch.png',
		},
		{
			name: 'Instagram',
			link: 'https://www.instagram.com/nelaabib/',
			icon: 'ig.png',
		},
		{
			name: 'Contact',
			link: 'mailto:hello@nelaabib.com?subject=from website&body=Hey Nela,',
			icon: 'mail.png',
		},
	]
</script>

<main>r
	<section style="display: grid; gap: 1rem; padding-top: 5rem;">
		<iframe loading="lazy" title="Spotify Embed: The Future" width="300" height="160" frameborder="0" allowfullscreen="" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" src="https://open.spotify.com/embed/album/4yVDN9Zpfme1EtY5jNjX63?si=COORP7aXSZyeRfTWqf_hDg&amp;dl_branch=1"></iframe>
		<iframe loading="lazy" title="Spotify Embed: The Future" width="300" height="160" frameborder="0" allowfullscreen="" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" src="https://open.spotify.com/embed/album/142k9rmYiBSeNqjgUSlVQZ?si=COORP7aXSZyeRfTWqf_hDg&amp;dl_branch=1"></iframe>
		<iframe loading="lazy" title="Spotify Embed: The Future" width="300" height="160" frameborder="0" allowfullscreen="" allow="autoplay; encrypted-media; fullscreen; picture-in-picture" src="https://open.spotify.com/embed/album/6QSq6fB5vMB4g1qH8V2woh?si=COORP7aXSZyeRfTWqf_hDg&amp;dl_branch=1"></iframe>
	</section>
	

	{#each links as link}
		<a href="{link.link}" target="_blank">
			<span>
				{#if link.icon}
				<div class="icon">
					<img style="width: 48px" src="images/{link.icon}" alt="{link.name} icon" />
				</div>
				{/if}
				{link.name}
			</span>
		</a>
	{/each}
	<h1>A 10MIL</h1>
	<h1 style="margin-top: -3rem;">Out Now</h1>
	<iframe 
		width="100%" 
		height="600" 
		src="https://www.youtube.com/embed/1mjbOCKvCxg" 
		title="YouTube video player" 
		frameborder="0" 
		allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
		allowfullscreen>
	</iframe> 
	<img src="images/3000.jpg" alt="" />
</main>

<style>
	.icon {
		/* display: inline; */
		position: absolute;
    	margin-left: 1rem;
    	margin-top: -.9rem;
		filter: invert(0);
	}
	span {
		display: inline-block;
		background-color: rgba(34, 34, 34, 0.5);
		/* filter: blur(9px); */
		box-shadow: 0px 0 20px 0 rgba(0,0,0,0.5);
		color: white;
		transition: background-color 0.7s;
		padding: 1rem .1rem;
		min-width: 17rem;
		max-width: 25rem;
		margin-top: 1rem;
		border-radius: 3rem;
		/* text-align: center; */

	}
	span:hover {
		background-color: rgb(255, 255, 255);
		color: black;
		transition: background-color 0.7s;
		box-shadow: #55555599 1rem;
	}
	span:hover .icon {
		filter: invert(1);
	}
	:global(body) {
    	
		background: url('../images/512.jpg') 50% 50% fixed;
	}
	img {
		width: 100%;
	}
	main {
		display: grid;
		justify-items: center;
		text-align: center;
		padding: 0;
		margin: 0;
		/* max-width: 240px;
		margin: 0 auto; */
	}
	:global(body) {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	h1 {
		color: #f8f8f8;
		text-transform: uppercase;
		font-size: 3em;
		font-weight: 700;
	}

	@media (max-width: 640px) {
		main {
			grid-gap: 0.5rem;
			padding: 0;
			max-width: none;
		}
	}
</style>